// extracted by mini-css-extract-plugin
module.exports = {"content":"AppDate_content__2YhMF","time":"AppDate_time__1CS5W","date":"AppDate_date__1Nx_-","rotating":"AppDate_rotating__2b44N"};